import React, { useState, useEffect } from 'react';
import './LandingPage.css';
import mbIcon from '../assets/mb_icon.png';
import dpsLogo from '../assets/dps-logo.png'
import pvslogo from '../assets/pvs-logo.png'
import rgpvlogo from '../assets/RGPVLOGO.jpg'
import Carmellogo from '../assets/CarmelConvent.png'
import maplebearlogo from '../assets/maplebear.png'
import oneworldlogo from '../assets/one_worldlogo.jpg'

interface LandingPageProps {
  onNavigateToLogin: () => void;
  onNavigateToContact: () => void;
  onNavigateToPartner: () => void;
  onNavigateToAbout: () => void;
  onNavigateToPricing: () => void;
  onNavigateToFeatures: (section?: string) => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onNavigateToLogin, onNavigateToContact, onNavigateToPartner, onNavigateToAbout, onNavigateToPricing, onNavigateToFeatures }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showFaqModal, setShowFaqModal] = useState(false);
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  // FAQs data
  const faqs = [
    {
      question: 'What is My Learning Board?',
      answer: 'My Learning Board is a comprehensive school management system powered by Agentic AI. It helps schools manage students, fees, HR, attendance, and communication all in one platform.'
    },
    {
      question: 'How does the WhatsApp integration work?',
      answer: 'Our WhatsApp integration allows schools to send bulk messages, fee reminders, attendance alerts, and exam notifications directly to parents. Parents can also respond and communicate with the school through WhatsApp.'
    },
    {
      question: 'Is my data secure?',
      answer: 'Yes, we use industry-standard encryption (SSL/TLS) for all data in transit and at rest. Your data is stored securely on Firebase/Firestore cloud infrastructure with strict access controls.'
    },
    {
      question: 'Can I import existing student data?',
      answer: 'Yes, My Learning Board supports bulk upload of student data via Excel files with validation and duplicate detection. You can easily migrate your existing data to our platform.'
    },
    {
      question: 'Is there a mobile app available?',
      answer: 'Yes, My Learning Board is available on both Google Play Store and Apple App Store for teachers, students, and parents to access on the go.'
    },
    {
      question: 'What payment methods are supported for fee collection?',
      answer: 'We support online payments through Razorpay integration, allowing parents to pay fees via UPI, credit/debit cards, net banking, and wallets. Offline payment recording is also available.'
    },
    {
      question: 'How do I get started?',
      answer: 'Simply click on "Book a Demo" to schedule a personalized demonstration. Our team will walk you through all features and help you set up your school on the platform.'
    },
    {
      question: 'Is training provided for staff?',
      answer: 'Yes, we provide comprehensive training for administrators, teachers, and staff. Our support team is also available to assist with any questions during and after implementation.'
    }
  ];

  // Schools data
  const schools = [
    {
      name: 'Delhi Public School',
      logo: dpsLogo
    },
    {
      name: 'Pearls Valley School',
      logo: pvslogo
    },
    {
      name: 'RGPV Bhopal',
      logo: rgpvlogo
    },
    {
      name: 'Carmel Convent School',
      logo: Carmellogo
    },
    {
      name: 'Maple Bear Canadian School',
      logo: maplebearlogo
    },
    {
      name: 'One World International School',
      logo:  oneworldlogo
    }
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="landing-page">
      {/* Navigation Header */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container-fluid px-4">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <img src={mbIcon} alt="MB Icon" className="mb-logo" />
            <span className="ms-2 fw-bold text-primary-custom">My Learning Board</span>
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a className="nav-link active" href="#">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); onNavigateToAbout(); }}>About Us</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); onNavigateToPricing(); }}>Pricing</a>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  Features
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('student-management'); }}>Student Management</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('fee-management'); }}>Fee Management</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('hr-management'); }}>HR Management</a></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('whatsapp-integration'); }}>WhatsApp Integration</a></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><a className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); onNavigateToFeatures(); }}>View All Features</a></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  Product & Services
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#">ERP System</a></li>
                  <li><a className="dropdown-item" href="#">Mobile App</a></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                  Resources
                </a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item" href="#">Blog</a></li>
                  <li><a className="dropdown-item" href="#">Documentation</a></li>
                </ul>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); onNavigateToPartner(); }}>Become A Partner</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); onNavigateToContact(); }}>Contact Us</a>
              </li>
            </ul>

            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-primary-custom"
                onClick={onNavigateToLogin}
              >
                Login
              </button>
              <a className="btn btn-primary-custom text-white" href="https://calendar.app.google/V6NvTPtpmz65BXVZ6" target="_blank" rel="noopener noreferrer">
                Book a demo
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background"></div>
        <div className="container-fluid px-4">
          <div className="row align-items-center min-vh-80">
            <div className="col-lg-6">
              <h1 className="display-3 fw-bold text-white mb-3">
                A New Era of Education Management — Powered by Agentic AI
              </h1>
              <h2 className="h4 text-white-50 mb-4">
                Still Struggling with ERP? It's Time for an Intelligent Upgrade.
              </h2>
              <p className="lead text-white mb-4">
                ERP alone isn't enough anymore. Schools and Colleges today need smarter systems that think, predict, and adapt. My Learning Board brings <strong>Agentic AI</strong> into the classroom — solving the very problems ERPs leave behind.
              </p>
              <a className="btn btn-primary-custom btn-lg text-white" href="https://calendar.app.google/V6NvTPtpmz65BXVZ6" target="_blank" rel="noopener noreferrer">
                Get a personalized demo
              </a>
            </div>
            <div className="col-lg-6">
              <div className="laptop-mockup">
                <video
                  className="img-fluid rounded shadow-lg"
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{ width: '65%', height: '75%', margin: '0 auto', display: 'block', border: '5px solid #FAFAFA' }}
                >
                  <source src="/videos/dashboard-preview.mp4" type="video/mp4" />
                  <source src="/videos/dashboard-preview.webm" type="video/webm" />
                  {/* Fallback image if video doesn't load */}
                  <img
                    src="https://via.placeholder.com/800x500/1a1a1a/FFFFFF?text=Dashboard+Preview"
                    alt="Dashboard Preview"
                    className="img-fluid rounded shadow-lg"
                  />
                </video>
              </div>
            </div>
          </div>

          {/* Carousel indicators */}
          <div className="carousel-indicators-custom">
            {[0, 1, 2].map((index) => (
              <button
                key={index}
                className={`indicator ${currentSlide === index ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              ></button>
            ))}
          </div>
        </div>
      </section>

      {/* Schools Section */}
      <section className="schools-section py-5 bg-light">
        <div className="container-fluid px-4">
          <h2 className="text-center mb-5 display-6 text-primary-custom">
            Used Across Schools, Colleges And Universities Globally
          </h2>

          <div className="schools-carousel-container">
            <div className="schools-carousel">
              {/* Duplicate the schools array for seamless infinite scroll */}
              {[...schools, ...schools, ...schools].map((school, index) => (
                <div key={index} className="school-card">
                  <div className="school-logo-wrapper">
                    <img
                      src={school.logo}
                      alt={school.name}
                      className="school-logo"
                    />
                  </div>
                  <h5 className="school-name text-center mt-3">{school.name}</h5>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer bg-dark text-white py-3">
        <div className="container-fluid px-4 pt-4">
          <div className="row">
            {/* Company Info */}
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="mt-3 d-flex gap-3 align-items-start">
                <img src={mbIcon} alt="My Learning Board" className="footer-logo mt-3" />
                <div>
                  <p className="mb-1"><strong>Omnix Digital Solutions</strong></p>
                  <p className="text-muted small mb-0">
                    Survey No. 69/1, 69/2 & 69/3, Hobli,<br />
                    off Sarjapur Rd, Kodathi Village,<br />
                    Varthur, Bengaluru, Karnataka 560035
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-3">
              <h6 className="mb-3">Quick Links</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToAbout(); }}>
                    About Us
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToPricing(); }}>
                    Pricing
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToContact(); }}>
                    Contact Us
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); setShowFaqModal(true); }}>
                    FAQs
                  </a>
                </li>
              </ul>
            </div>

            {/* Features */}
            <div className="col-lg-2 col-md-6 mb-3">
              <h6 className="mb-3">Features</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('student-management'); }}>Student Management</a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('fee-management'); }}>Fee Management</a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('hr-management'); }}>HR Management</a>
                </li>
                <li className="mb-2">
                  <a href="#" className="footer-link" onClick={(e) => { e.preventDefault(); onNavigateToFeatures('whatsapp-integration'); }}>WhatsApp Integration</a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4 col-md-6 mb-3">
              <h6 className="mb-3">Contact Information</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-envelope me-2"></i>
                  <a href="mailto:contact@mylearningboard.com" className="footer-link">
                    contact@mylearningboard.com
                  </a>
                </li>
                <li className="mb-2">
                  <i className="bi bi-globe me-2"></i>
                  <span className="text-muted small">Available on Google Play Store & Apple App Store</span>
                </li>
              </ul>
              <div className="mt-3">
                <h6 className="mb-2">Follow Us</h6>
                <div className="d-flex gap-3">
                  <a href="#" className="footer-social-link">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="#" className="footer-social-link">
                    <i className="bi bi-twitter"></i>
                  </a>
                  <a href="#" className="footer-social-link">
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a href="#" className="footer-social-link">
                    <i className="bi bi-instagram"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="row mt-4 pt-3 border-top border-secondary">
            <div className="col-md-6 text-center text-md-start">
              <p className="small text-muted mb-0">
                &copy; 2026 Omnix Digital Solutions. All rights reserved.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <a href="#" className="footer-link small me-3">Terms of Service</a>
              <a href="#" className="footer-link small me-3" onClick={(e) => { e.preventDefault(); setShowPrivacyModal(true); }}>Privacy Policy</a>
              <a href="#" className="footer-link small">Cookie Policy</a>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowPrivacyModal(false)}>
          <div className="modal-dialog modal-dialog-scrollable modal-xl" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header bg-primary-custom text-white">
                <h5 className="modal-title">
                  <i className="bi bi-shield-lock me-2"></i>
                  Privacy Policy for My Learning Board
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowPrivacyModal(false)}></button>
              </div>
              <div className="modal-body">
                <p className="text-muted"><strong>Last updated: November 19, 2025</strong></p>

                <h5>Introduction</h5>
                <p>
                  Omnix Digital Solutions ("we," "our," or "us") operates the My Learning Board mobile application (the "App") available on Google Play Store and Apple App Store. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our educational management application.
                </p>
                <p>
                  By using My Learning Board, you agree to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our App.
                </p>

                <h5 className="mt-4">Google Play Data Safety Disclosure</h5>
                <p>
                  In compliance with Google Play's Data safety requirements, we provide the following transparency about our data practices:
                </p>

                <h6>Data Collection and Sharing</h6>
                <p><strong>We collect the following types of user data:</strong></p>
                <ul>
                  <li><strong>Personal Information:</strong> Name, email address, phone number (for account registration and communication)</li>
                  <li><strong>User IDs:</strong> To identify and authenticate users within the App</li>
                  <li><strong>Messages:</strong> In-app communications between students, teachers, and administrators</li>
                  <li><strong>Photos:</strong> Profile pictures and assignment-related images (optional)</li>
                  <li><strong>Files and Documents:</strong> Educational materials, assignments, and documents uploaded by users</li>
                  <li><strong>App Activity:</strong> App interactions, in-app search history, and other user-generated content</li>
                  <li><strong>App Performance Data:</strong> Crash logs, diagnostics, and other app performance data for troubleshooting</li>
                  <li><strong>Device or Other IDs:</strong> Device identifiers for app functionality and analytics</li>
                </ul>

                <h6>Data Usage Purposes</h6>
                <p>The data we collect is used for the following purposes:</p>
                <ul>
                  <li><strong>App Functionality:</strong> To provide core educational management features</li>
                  <li><strong>Analytics:</strong> To understand usage patterns and improve the App</li>
                  <li><strong>Developer Communications:</strong> To send important updates and notifications</li>
                  <li><strong>Fraud Prevention and Security:</strong> To protect user accounts and maintain app security</li>
                  <li><strong>Personalization:</strong> To customize your experience within the App</li>
                  <li><strong>Account Management:</strong> To manage user accounts and preferences</li>
                </ul>

                <h6>Data Sharing Practices</h6>
                <p><strong>We share data with the following categories of third parties:</strong></p>
                <ul>
                  <li><strong>Service Providers:</strong> We share data with Firebase/Firestore and other service providers who help us operate the App</li>
                  <li><strong>Within Your School:</strong> Student and teacher data is accessible to authorized users within your educational institution</li>
                  <li><strong>No Sale of Data:</strong> We do not sell or rent your personal information to third parties for their marketing purposes</li>
                </ul>

                <h6>Security Practices</h6>
                <p>
                  <strong>All user data collected by our App is encrypted in transit</strong> using industry-standard SSL/TLS protocols. Data stored on our servers is protected with encryption at rest and other security measures to prevent unauthorized access.
                </p>

                <h6>User Data Deletion</h6>
                <p>
                  <strong>We provide a way for users to request that their data be deleted.</strong> You may request deletion of your account and associated data by contacting us at the email address provided below. We will process deletion requests within 30 days, except where data retention is required by law.
                </p>

                <h5 className="mt-4">Apple App Store Privacy Requirements</h5>
                <p>
                  In accordance with Apple's App Store Review Guidelines and privacy requirements, we provide the following disclosures:
                </p>

                <h6>Data Collection Disclosure</h6>
                <ul>
                  <li><strong>What data we collect:</strong> We collect personal information including names, email addresses, phone numbers, student academic records, messages, photos, files, device identifiers, and usage data.</li>
                  <li><strong>How we collect data:</strong> Data is collected directly from users during account creation, through app usage, file uploads, messaging features, and automatically through device sensors and analytics.</li>
                  <li><strong>How we use data:</strong> We use collected data to provide educational management services, facilitate school communications, manage academic records and timetables, send notifications, improve app functionality, and ensure security.</li>
                  <li><strong>Third-party data sharing:</strong> We only share user data with service providers (Firebase/Firestore, cloud messaging services) that maintain strong privacy practices and are bound by strict confidentiality agreements.</li>
                  <li><strong>Data retention:</strong> We retain user data for as long as necessary to provide services and comply with legal obligations.</li>
                  <li><strong>User consent revocation:</strong> Users can revoke consent and opt out of data collection by disabling specific app features, adjusting device settings, or contacting us to delete their account.</li>
                  <li><strong>Data deletion requests:</strong> Users can request deletion of their personal data at any time by contacting us, and we will process such requests within 30 days.</li>
                </ul>

                <h5 className="mt-4">Information We Collect</h5>
                <h6>Personal Information</h6>
                <p>We may collect the following types of personal information:</p>
                <ul>
                  <li><strong>Account Information:</strong> Name, email address, phone number, and password when you create an account</li>
                  <li><strong>Student Information:</strong> Student names, class/grade levels, enrollment details, and academic records</li>
                  <li><strong>Teacher Information:</strong> Teacher profiles, credentials, and contact information</li>
                  <li><strong>User-Generated Content:</strong> Messages, assignments, grades, timetables, and other educational content shared through the App</li>
                </ul>

                <h6>Automatically Collected Information</h6>
                <p>When you use the App, we automatically collect certain information, including:</p>
                <ul>
                  <li><strong>Device Information:</strong> Device model, operating system version, unique device identifiers</li>
                  <li><strong>Usage Data:</strong> App features accessed, time spent on the App, interaction patterns</li>
                  <li><strong>Log Data:</strong> IP address, app crashes, system activity, and the date/time of your requests</li>
                </ul>

                <h6>Permissions</h6>
                <p>The App may request the following permissions:</p>
                <ul>
                  <li><strong>Storage:</strong> To save and access documents, images, and educational materials</li>
                  <li><strong>Camera:</strong> To capture photos for profiles or assignments (if enabled)</li>
                  <li><strong>Notifications:</strong> To send alerts about assignments, messages, and updates</li>
                  <li><strong>Internet Access:</strong> To sync data and enable real-time messaging features</li>
                </ul>

                <h5 className="mt-4">How We Use Your Information</h5>
                <p>We use the collected information for the following purposes:</p>
                <ul>
                  <li>To provide and maintain the App's educational management services</li>
                  <li>To facilitate communication between students, teachers, and administrators</li>
                  <li>To manage timetables, assignments, and academic records</li>
                  <li>To send notifications about important updates, assignments, and school activities</li>
                  <li>To improve and personalize your experience with the App</li>
                  <li>To monitor and analyze usage patterns to enhance app functionality</li>
                  <li>To detect, prevent, and address technical issues and security threats</li>
                  <li>To comply with legal obligations and enforce our terms of service</li>
                </ul>

                <h5 className="mt-4">Data Storage and Security</h5>
                <p>
                  We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your data is stored on secure servers using Firebase/Firestore cloud infrastructure with encryption in transit and at rest.
                </p>
                <ul>
                  <li><strong>Encryption in Transit:</strong> All data transmitted between your device and our servers is encrypted using SSL/TLS protocols.</li>
                  <li><strong>Encryption at Rest:</strong> Data stored on our servers is encrypted to protect against unauthorized access.</li>
                </ul>
                <p>
                  However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>

                <h5 className="mt-4">Third-Party Services</h5>
                <p>Our App may use third-party services that collect information used to identify you:</p>
                <ul>
                  <li><strong>Firebase/Firestore:</strong> For cloud database and authentication services</li>
                  <li><strong>Google Analytics for Firebase:</strong> For app analytics and usage statistics (if implemented)</li>
                  <li><strong>Cloud Messaging Services:</strong> For push notifications</li>
                </ul>
                <p>
                  All third-party service providers we work with maintain strong privacy practices and are subject to strict confidentiality agreements. These third-party service providers have their own privacy policies governing their use of your information. We encourage you to review their privacy policies.
                </p>

                <h5 className="mt-4">Data Sharing and Disclosure</h5>
                <p>We do not sell, trade, or rent your personal information to third parties. We may share your information in the following circumstances:</p>
                <ul>
                  <li><strong>Within the School Community:</strong> Student and teacher information is shared within your educational institution as necessary for the App's functionality</li>
                  <li><strong>Service Providers:</strong> With trusted third-party service providers who assist us in operating the App, subject to strict confidentiality obligations</li>
                  <li><strong>With Your Consent:</strong> When you explicitly authorize us to share specific information</li>
                  <li><strong>Legal Requirements:</strong> When required by law, court order, or governmental authority to comply with legal processes</li>
                  <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets, where user data may be transferred to the acquiring entity</li>
                </ul>

                <h5 className="mt-4">Children's Privacy</h5>
                <p>
                  My Learning Board is designed for use by educational institutions and may be used by children under 13 years of age. We comply with the Children's Online Privacy Protection Act (COPPA) and similar regulations. We collect information from children only with verifiable parental or school consent. Parents and guardians have the right to review, delete, or refuse further collection of their child's information by contacting us.
                </p>

                <h5 className="mt-4">Data Retention and Deletion</h5>
                <p>
                  We retain your personal information for as long as necessary to provide the App's services and comply with legal obligations.
                </p>
                <p>
                  <strong>You have the right to request deletion of your data.</strong> You may request deletion of your account and associated data at any time by contacting us at the email address below. Upon request, we will delete your information within 30 days, except where retention is required by law or for legitimate business purposes.
                </p>

                <h5 className="mt-4">Your Rights and Choices</h5>
                <p>You have the following rights regarding your personal information:</p>
                <ul>
                  <li><strong>Access:</strong> Request access to the personal information we hold about you</li>
                  <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
                  <li><strong>Deletion:</strong> Request deletion of your personal information</li>
                  <li><strong>Data Portability:</strong> Request a copy of your data in a structured, machine-readable format</li>
                  <li><strong>Opt-Out:</strong> Disable push notifications through your device settings</li>
                  <li><strong>Withdraw Consent:</strong> Revoke your consent to data processing at any time</li>
                </ul>
                <p>To exercise these rights, please contact us using the information provided below.</p>

                <h5 className="mt-4">Updates to This Privacy Policy</h5>
                <p>
                  We may update this Privacy Policy from time to time to reflect changes in our practices, legal requirements, Google Play Data safety requirements, or Apple App Store privacy requirements. We will notify you of any material changes by posting the new Privacy Policy in the App and updating the "Last updated" date. Your continued use of the App after such changes constitutes acceptance of the updated policy.
                </p>

                <h5 className="mt-4">Contact Us</h5>
                <p>
                  If you have questions, concerns, or requests regarding this Privacy Policy, our data practices, or wish to request deletion of your data, please contact us at:
                </p>
                <div className="bg-light p-3 rounded">
                  <p className="mb-1"><strong>Company Name:</strong> Omnix Digital Solutions</p>
                  <p className="mb-1"><strong>Email:</strong> <a href="mailto:contact@mylearningboard.com">contact@mylearningboard.com</a></p>
                  <p className="mb-1"><strong>App Name:</strong> My Learning Board</p>
                  <p className="mb-0"><strong>Address:</strong> Survey No. 69/1, 69/2 & 69/3, Hobli, off Sarjapur Rd, Kodathi Village, Varthur, Bengaluru, Karnataka 560035</p>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowPrivacyModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FAQ Modal */}
      {showFaqModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowFaqModal(false)}>
          <div className="modal-dialog modal-dialog-scrollable modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header bg-primary-custom text-white">
                <h5 className="modal-title">
                  <i className="bi bi-question-circle me-2"></i>
                  Frequently Asked Questions
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowFaqModal(false)}></button>
              </div>
              <div className="modal-body p-4">
                <div className="accordion" id="faqAccordion">
                  {faqs.map((faq, index) => (
                    <div className="accordion-item border-0 mb-3" key={index}>
                      <h2 className="accordion-header">
                        <button
                          className={`accordion-button ${expandedFaq === index ? '' : 'collapsed'} bg-light rounded`}
                          type="button"
                          onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                          style={{ boxShadow: 'none' }}
                        >
                          <i className={`bi ${expandedFaq === index ? 'bi-dash-circle' : 'bi-plus-circle'} me-2`} style={{ color: '#5C2597' }}></i>
                          <strong>{faq.question}</strong>
                        </button>
                      </h2>
                      <div className={`accordion-collapse collapse ${expandedFaq === index ? 'show' : ''}`}>
                        <div className="accordion-body text-muted pt-3">
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="text-center mt-4 pt-3 border-top">
                  <p className="text-muted mb-2">Still have questions?</p>
                  <button className="btn btn-primary-custom text-white" onClick={() => { setShowFaqModal(false); onNavigateToContact(); }}>
                    <i className="bi bi-envelope me-2"></i>Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPage;
